var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _dec7, _dec8, _class2, _descriptor7, _descriptor8, _dec9, _dec0, _dec1, _dec10, _dec11, _class3, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _class4, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import objectTrait from "../Decorators/objectTrait";
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
import ClippingPlanesTraits from "./ClippingPlanesTraits";
import HighlightColorTraits from "./HighlightColorTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import MappableTraits from "./MappableTraits";
import OpacityTraits from "./OpacityTraits";
import PlaceEditorTraits from "./PlaceEditorTraits";
import ShadowTraits from "./ShadowTraits";
import SplitterTraits from "./SplitterTraits";
import TransformationTraits from "./TransformationTraits";
import UrlTraits from "./UrlTraits";
import FeaturePickingTraits from "./FeaturePickingTraits";
import CesiumIonTraits from "./CesiumIonTraits";
import LayerOrderingTraits from "./LayerOrderingTraits";
export let FilterTraits = (_dec = primitiveTrait({
  type: "string",
  name: "Name",
  description: "A name for the filter"
}), _dec2 = primitiveTrait({
  type: "string",
  name: "property",
  description: "The name of the feature property to filter"
}), _dec3 = primitiveTrait({
  type: "number",
  name: "minimumValue",
  description: "Minimum value of the property"
}), _dec4 = primitiveTrait({
  type: "number",
  name: "minimumValue",
  description: "Minimum value of the property"
}), _dec5 = primitiveTrait({
  type: "number",
  name: "minimumShown",
  description: "The lowest value the property can have if it is to be shown"
}), _dec6 = primitiveTrait({
  type: "number",
  name: "minimumValue",
  description: "The largest value the property can have if it is to be shown"
}), _class = class FilterTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "property", _descriptor2, this);
    _initializerDefineProperty(this, "minimumValue", _descriptor3, this);
    _initializerDefineProperty(this, "maximumValue", _descriptor4, this);
    _initializerDefineProperty(this, "minimumShown", _descriptor5, this);
    _initializerDefineProperty(this, "maximumShown", _descriptor6, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "property", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "minimumValue", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "maximumValue", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "minimumShown", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "maximumShown", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export let PointCloudShadingTraits = (_dec7 = primitiveTrait({
  type: "boolean",
  name: "Attenuation",
  description: "Perform point attenuation based on geometric error."
}), _dec8 = primitiveTrait({
  type: "number",
  name: "geometricErrorScale",
  description: "Scale to be applied to each tile's geometric error."
}), _class2 = class PointCloudShadingTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "attenuation", _descriptor7, this);
    _initializerDefineProperty(this, "geometricErrorScale", _descriptor8, this);
  }
}, _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "attenuation", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "geometricErrorScale", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export let OptionsTraits = (_dec9 = primitiveTrait({
  type: "number",
  name: "Maximum screen space error",
  description: "The maximum screen space error used to drive level of detail refinement."
}), _dec0 = primitiveTrait({
  type: "number",
  name: "Maximum number of loaded tiles",
  description: ""
}), _dec1 = objectTrait({
  type: PointCloudShadingTraits,
  name: "Point cloud shading",
  description: "Point cloud shading parameters"
}), _dec10 = primitiveTrait({
  type: "boolean",
  name: "Show credits on screen",
  description: "Whether to display the credits of this tileset on screen."
}), _dec11 = primitiveTrait({
  type: "boolean",
  name: "Asynchronously load draped imageries",
  description: "When true, Cesium does not wait for the draped imagery layers to load before the tileset mesh is rendered. This means while the imagery is being loaded the original tile texture will be shown."
}), _class3 = class OptionsTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "maximumScreenSpaceError", _descriptor9, this);
    _initializerDefineProperty(this, "maximumNumberOfLoadedTiles", _descriptor0, this);
    _initializerDefineProperty(this, "pointCloudShading", _descriptor1, this);
    _initializerDefineProperty(this, "showCreditsOnScreen", _descriptor10, this);
    _initializerDefineProperty(this, "asynchronouslyLoadImagery", _descriptor11, this);
  }
}, _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, "maximumScreenSpaceError", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class3.prototype, "maximumNumberOfLoadedTiles", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class3.prototype, "pointCloudShading", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class3.prototype, "showCreditsOnScreen", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class3.prototype, "asynchronouslyLoadImagery", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _class3);
let Cesium3DTilesTraits = (_dec12 = objectTrait({
  type: OptionsTraits,
  name: "options",
  description: "Additional options to pass to Cesium's Cesium3DTileset constructor."
}), _dec13 = anyTrait({
  name: "style",
  description: "The style to use, specified according to the [Cesium 3D Tiles Styling Language](https://github.com/AnalyticalGraphicsInc/3d-tiles/tree/master/specification/Styling)."
}), _dec14 = objectArrayTrait({
  type: FilterTraits,
  idProperty: "name",
  name: "filters",
  description: "The filters to apply to this catalog item."
}), _dec15 = primitiveTrait({
  name: "Color blend mode",
  type: "string",
  description: "The color blend mode decides how per-feature color is blended with color defined in the tileset. Acceptable values are HIGHLIGHT, MIX & REPLACE as defined in the cesium documentation - https://cesium.com/docs/cesiumjs-ref-doc/Cesium3DTileColorBlendMode.html"
}), _dec16 = primitiveTrait({
  name: "Color blend amount",
  type: "number",
  description: "When the colorBlendMode is MIX this value is used to interpolate between source color and feature color. A value of 0.0 results in the source color while a value of 1.0 results in the feature color, with any value in-between resulting in a mix of the source color and feature color."
}), _dec17 = primitiveArrayTrait({
  name: "Feature ID properties",
  type: "string",
  description: "One or many properties of a feature that together identify it uniquely. This is useful for setting properties for individual features. eg: ['lat', 'lon'], ['buildingId'] etc."
}), _dec18 = primitiveArrayTrait({
  name: "lightColor",
  type: "number",
  description: "The light color when shading models. When undefined the scene's light color is used instead. eg: [255, 255, 255]."
}), _dec19 = primitiveTrait({
  name: "Drape imagery",
  type: "boolean",
  description: "When true allows draping imagery on top of this tileset. Imagery items appearing above this catalog item in the workbench will be draped on top of the tileset."
}), _class4 = class Cesium3DTilesTraits extends mixTraits(HighlightColorTraits, PlaceEditorTraits, TransformationTraits, FeaturePickingTraits, MappableTraits, UrlTraits, CatalogMemberTraits, ShadowTraits, OpacityTraits, LegendOwnerTraits, ShadowTraits, ClippingPlanesTraits, SplitterTraits, LayerOrderingTraits, CesiumIonTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "options", _descriptor12, this);
    _initializerDefineProperty(this, "style", _descriptor13, this);
    _initializerDefineProperty(this, "filters", _descriptor14, this);
    _initializerDefineProperty(this, "colorBlendMode", _descriptor15, this);
    _initializerDefineProperty(this, "colorBlendAmount", _descriptor16, this);
    _initializerDefineProperty(this, "featureIdProperties", _descriptor17, this);
    _initializerDefineProperty(this, "lightColor", _descriptor18, this);
    _initializerDefineProperty(this, "drapeImagery", _descriptor19, this);
  }
}, _descriptor12 = _applyDecoratedDescriptor(_class4.prototype, "options", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class4.prototype, "style", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class4.prototype, "filters", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class4.prototype, "colorBlendMode", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "MIX";
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class4.prototype, "colorBlendAmount", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0.5;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class4.prototype, "featureIdProperties", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class4.prototype, "lightColor", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class4.prototype, "drapeImagery", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class4);
export { Cesium3DTilesTraits as default };